import uns from "underscore.string"

const escapeParam = function(param) {
  //return uns.replaceAll(param, "&", "%26")
  return param //encodeURIComponent(param)
}

export {
  escapeParam
}



// WEBPACK FOOTER //
// ./src/service/UrlEncoder.js